import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import { CustomerShape, CustomersResponseShape } from 'models/customers';

export const CustomersApi = createApi({
  reducerPath: 'customersApi',
  tagTypes: ['customers', 'contact', 'customer'],
  baseQuery,
  endpoints: (builder) => ({
    getTableData: builder.query<CustomersResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['customers'],
    }),
    getCustomer: builder.query<CustomerShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['customer'],
    }),
    deleteCustomerByID: builder.mutation<CustomerShape, string>({
      query: (url) => ({
        url: url,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetTableDataQuery,
  useGetCustomerQuery,
  useDeleteCustomerByIDMutation,
} = CustomersApi;
